/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Profile_Email_Sent_ToInputs */



/**
* | output |
* | --- |
* | "We sent a link to {email}" |
*
* @param {Profile_Email_Sent_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_email_sent_to = /** @type {((inputs: Profile_Email_Sent_ToInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Email_Sent_ToInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Nous avons envoyé un lien à ${i?.email}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Hemos enviado un enlace a ${i?.email}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Enviamos um link para ${i?.email}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Abbiamo inviato un link a ${i?.email}`)
	return /** @type {LocalizedString} */ (`We sent a link to ${i?.email}`)
});